import {InjectionToken} from '@angular/core';
import {Link} from '../models';
import {NavDropdownItem} from "../nav-dropdown";

export class MasterConfig {
    links: Link[];
    usuarioLinks: Link[];
    titulo: string;
    rota: string;
    imgUrl: string;
    notificacao: boolean;
    multiConta: boolean;
    permicaoAmbiente: string;
    modulo: string;
    ambiente: string;
    itens?: NavDropdownItem[];
    itemSelecionado?: NavDropdownItem;
    iconeDespachante: string;

    constructor() {
        this.titulo = 'Aplicação';
        this.rota = '/home';
        this.imgUrl = '';
        this.itens = [];
        this.links = [
            { titulo: 'Home', icone: 'home', label: 'Home', rota: '/' }
        ];
        this.notificacao = false;
        this.multiConta = false;
        this.permicaoAmbiente = 'Producao';
        this.modulo = null;
        this.ambiente = '';
        this.usuarioLinks = [];
        this.iconeDespachante = '';
    }
}

export const MASTER_OPTIONS_FACTORY = () => new MasterConfig();

export const MASTER_DEFAULT_OPTIONS =
    new InjectionToken<MasterConfig>('master-default-options', {
        providedIn: 'root',
        factory: MASTER_OPTIONS_FACTORY,
    });
